import { render, staticRenderFns } from "./OW-003-Scholarship.vue?vue&type=template&id=6d05ca32&"
import script from "./OW-003-Scholarship.vue?vue&type=script&lang=js&"
export * from "./OW-003-Scholarship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports